import { Component, OnInit, ChangeDetectorRef, Optional, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatSnackBar } from '@angular/material';

import { ErrorDialogComponent } from '../../dialog/errordialog/error.dialog.component';

import { UserLoginService } from '../../service/aws/user.login.service';

export class NewPasswordUser {
    username: string;
    existingPassword: string;
    password: string;
}
/**
 * This component is responsible for displaying and controlling
 * the registration of the user.
 */
@Component({
    selector: 'app-resetpassword',
    styleUrls: ['reset-password.component.scss'],
    templateUrl: './reset-password.component.html'
})
export class ResetPasswordComponent {
    showUserName: boolean;
    shoVc: boolean;
    showPwd: boolean;
    userName: string;
    vcode: string;
    pwd: string;
    pwdc: string;
    errorMessage: string;

    constructor(
        public userService: UserLoginService,
        private router: Router,
        private notification: MatSnackBar) {
        this.router = router;
        this.showUserName = true;
        this.shoVc = false;
        this.showPwd = false;
    }

    OnInit() {
        this.errorMessage = null;
    }

    OnReset() {
        if (this.userName && this.showUserName) {
            this.userService.forgotPassword(this.userName, this);
        } else if (this.vcode && this.shoVc){
            this.shoVc = false;
            this.showPwd = true;
        } else if (this.pwd && this.showPwd) {
            this.resetPass();
        }
        // this.userRegistration.newPassword(this.registrationUser, this);
    }

    cognitoCallback(message: string, result: any) {
        if (message === 'vcode') {
            this.notification.open('Verification code sent to ' + result + '.', 'Ok.', {
                duration: 2000
            });
            this.showUserName = false;
            this.shoVc = true;
        } else if (message === 'success') {
            this.notification.open('Password reset. Redirecting to login.', 'Ok.', {
                duration: 2000
            });
            setTimeout(() => {
                this.router.navigate(['/']);
            }, 3000);
        } else {
            this.notification.open(result, 'Ok.', {
                duration: 2000
            });
        }
    }

    resetPass() {
        if (this.userName &&
            this.vcode &&
            this.pwd &&
            this.pwdc &&
            this.pwd === this.pwdc) {
            this.userService.confirmNewPassword(
                this.userName,
                this.vcode,
                this.pwd,
                this);
        }
    }
}
